import React from 'react'

import { CountryCode } from '@app/consts/Countries'

import { FlagIcon } from '@ui/icons/flags'
import { IconFCType, IconProps } from '@ui/icons/types'

const localeToCountryCode: Record<string, CountryCode> = {
  en: 'USA',
  zh: 'CHN',
  tw: 'TWN',
  hk: 'HKG',
  it: 'ITA',
  pl: 'POL',
  es: 'ESP',
  th: 'THA',
  tr: 'TUR',
  ar: 'ARE',
  de: 'DEU',
  id: 'IDN',
  ko: 'KOR',
  kr: 'KOR',
  ms: 'MYS',
  pt: 'PRT',
  vi: 'VNM',
  ru: 'RUS',
  ja: 'JPN',
}

interface ResolveFlagIconProps extends IconProps {
  locale: string
}

const ResolveFlagIconBase: React.FC<ResolveFlagIconProps> = ({ locale, ...iconProps }) => {
  const countryCode = localeToCountryCode[locale]

  if (!countryCode) {
    return null
  }

  return <FlagIcon countryCode={countryCode} {...iconProps} />
}

export const makeResolveFlagIcon = (locale: string | null | undefined): IconFCType | undefined => {
  if (!locale || !localeToCountryCode[locale]) {
    return undefined
  }

  const Icon: React.FC<IconProps> = (iconProps) => (
    <ResolveFlagIconBase locale={locale} {...iconProps} />
  )
  Icon.displayName = `ResolveFlagIcon(${locale})`
  return Object.assign(Icon, { __isValidIcon: true as const })
}
